import { settingsMenus } from "@/components/navigation/links";
import { Outlet, useNavigate } from "react-router-dom";



import MenuLink from "@/components/navigation/MenuLink";
import Modal from "@/components/modal";



export default function SettingsLayout() {
        const navigate = useNavigate();

    const close = () => {
        navigate("/dashboard");
    }
    return (
        <Modal
            isOpen={true}
            onClose={close}
            size="xl"
            title="Settings"
            className="h-[760px] p-0"
        >
            <div className="w-full flex space-x-5 h-full border-t border-t-gray-200 p-[1px]">
                <div className="space-y-4 w-[250px] shrink-0 h-full px-1 py-2 border-r border-r-gray-200">
                            {settingsMenus.map((el) => (
                                    <div className="space-y-2" key={el.heading}>
                                        {
                                            el.menus.map((menu, index) => (
                                                <MenuLink
                                                    content={menu}
                                                    key={index}
                                                />
                                            ))
                                        }
                                    </div>
                                ))
                            }
                </div>

                {/* min-w-0 so the two-column forms inside can shrink instead of pushing the
                    modal sideways. */}
                <div className="flex-1 min-w-0">
                    <Outlet />
                </div>
            </div>
        </Modal>
    )
}